<template>
    <buttonComponents :width="width" :height="height"
    :queryConfig="queryConfig" :chartConfig="chartConfig"></buttonComponents>
</template>
<script>
  import buttonComponents from './components/buttonComponents.vue'
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      queryConfig: {
        type: Object,
        default () {
          return {
            checkUrl: null,
            submitUrl: null,
            params: []
          }
        }

      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            fontSize: 24,
            fontFamily: '微软雅黑',
            name: '标准标题',
            title: '标准标题',
            color: '#fff',
            background: 'rgba(0,0,0,0)',
            align: 'center',
            verticalAlign: 'middle',
            letterSpacing: 8,
            fontWeight: 'normal',
            border: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            borderTop: 'none',
            borderBottom: 'none',
            btnType: '',
            isBtnDefShow:false
          }
        }
      }
    },
    components: {
      buttonComponents
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/button.vue